import { PastelColors } from '@shared/constants';

export const makeColorTransparent = (hexColor: string, transparencyPercentage: number): string => {
  const [r, g, b] = hexToRgb(hexColor);
  const alpha = transparencyPercentage / 100;

  return rgbaToHex(r, g, b, alpha);
};

export function getRandomPastelColor(): string {
  const index = Math.floor(Math.random() * PastelColors.length);
  return PastelColors[index];
}

export const isDarkColor = (hexColor: string): boolean => {
  const [r, g, b] = hexToRgb(hexColor).map((c) => {
    const channel = c / 255;
    return channel <= 0.03928 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
  });
  const relativeLuminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return relativeLuminance < 0.179;
};

const hexToRgb = (hex: string): [number, number, number] => {
  let normalizedHex = hex.replace('#', '');
  if (normalizedHex.length <= 4) {
    normalizedHex = [...normalizedHex].map((c) => c + c).join('');
  }
  const bigint = parseInt(normalizedHex.slice(0, 6), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return [r, g, b];
};

const rgbaToHex = (r: number, g: number, b: number, a: number): string => {
  const toHex = (c: number) => c.toString(16).padStart(2, '0');
  const alphaHex = Math.round(a * 255)
    .toString(16)
    .padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}${alphaHex}`;
};
